import React from 'react';
import PageHeader from '../components/PageHeader.jsx';
import Slider from '../components/Slider.jsx';

const Awards = () => {
	let headerImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

	const sliderImages = [];

	for (let i = 1; i <= 10; i++) {
		sliderImages.push({
			path: `https://static.igem.wiki/teams/5066/awards/${i}.webp`,
		});
	}

	return (
		<div className='overflow-x-hidden'>
			<div className='bg-[#d9eaf0]'>
				<PageHeader img={headerImg} title='Awards' />
			</div>

			<div className='flex bg-gradient-to-b from-[#d9eaf0] via-[#e8f3f7] to-[#feedfb]'>
				<div className='flex flex-col mt-10 mb-10 lg:flex-row'>
					<div className='text-xl w-[400px] text-center flex flex-col lg:w-[790px] lg:mx-[50px] lg:text-left'>
						As we conclude this incredible year of designing,
						engineering, experimenting, and optimizing our project,
						we are filled with gratitude for the journey we’ve
						shared. The challenges we faced and the wonders we
						discovered have shaped an unforgettable experience. We
						are deeply honored to have been chosen as one of the two
						high school finalists and are overjoyed to receive the
						Grand Prize! Beyond that, our efforts in other areas
						were also recognized, allowing us to bring home three
						special prizes and three nominations to Taiwan.
						<br />
						<br />
						This achievement would not have been possible without
						the unwavering dedication of our team members, who
						committed their weekends to the project; our advisors,
						who passed down the passion and grit at GEMS Academy;
						our instructors, who laid the foundation for this
						amazing journey and showed firm belief in this project
						from the very beginning; and the professors and parents
						who supported us every step of the way.
						<br />
						<br />
						We extend our heartfelt thanks to iGEM for the
						recognition and for providing us with the opportunity to
						create such wonderful memories in 2024. It is with
						immense pride and gratitude that we celebrate these
						prizes and nominations—thank you to everyone who made
						this possible!
						<br />
						<br />
						<div className='w-full'>
							<Slider images={sliderImages} />
						</div>
					</div>
					<img
						style={{ width: '550px', height: 'auto', margin: 'auto', marginTop: 0 }}
						alt='Prizes'
						src='https://static.igem.wiki/teams/5066/awards/prizes-nb.webp'
					/>
				</div>
			</div>
		</div>
	);
};

export default Awards;
